"use strict";

var React = require('react');

var times = require('lodash/times');

function HorizontalLine() {
  return /*#__PURE__*/React.createElement("p", null, times(61, function () {
    return '-';
  }), /*#__PURE__*/React.createElement("br", null));
}

module.exports = HorizontalLine;